import type { Permissions, SchemaPlugin } from '@wix/wix-data-schema-types'
import {
  validateDisplayField,
  validateDisplayName,
  validateNamespace,
  validatePermissions,
} from '../validation/validators'
import type { Patch } from '../types'
import { PatchType } from '../types'

const setDisplayField = (value: string): Patch => {
  validateDisplayField(value)
  return {
    op: PatchType.ADD,
    path: `/displayField`,
    value,
  }
}

const removeDisplayField = (): Patch => {
  return {
    op: PatchType.REMOVE,
    path: `/displayField`,
  }
}

const setDisplayName = (value: string): Patch => {
  validateDisplayName(value)
  return {
    op: PatchType.ADD,
    path: `/displayName`,
    value,
  }
}

const setNamespace = (value: string): Patch => {
  validateNamespace(value)
  return {
    op: PatchType.ADD,
    path: `/namespace`,
    value,
  }
}

const setPermissions = (value: Permissions): Patch => {
  validatePermissions(value)
  return {
    op: PatchType.ADD,
    path: '/permissions',
    value,
  }
}

const setVersion = (value: number): Patch => {
  return {
    op: PatchType.ADD,
    path: `/version`,
    value,
  }
}

const enablePlugin = (pluginId: string, value: SchemaPlugin): Patch => {
  return {
    op: PatchType.ADD,
    path: `/plugins/${pluginId}`,
    value,
  }
}

const disablePlugin = (pluginId: string): Patch => {
  return {
    op: PatchType.REMOVE,
    path: `/plugins/${pluginId}`,
  }
}

const updatePlugin = (pluginId: string, value: SchemaPlugin): Patch => {
  return {
    op: PatchType.ADD,
    path: `/plugins/${pluginId}`,
    value,
  }
}

export {
  setDisplayField,
  removeDisplayField,
  setDisplayName,
  setNamespace,
  setPermissions,
  setVersion,
  enablePlugin,
  disablePlugin,
  updatePlugin,
}
